// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__2YQkp","title":"InfoRow_title__1E8tV"};